// extracted by mini-css-extract-plugin
module.exports = {"animateWrapper":"style_animateWrapper__I3rXJ","fadeIn":"style_fadeIn__PnEUY"};